module.exports = __webpack_public_path__ + "img/bet_amount_icon.be1e6d7e.svg";